export function getWhiteLabelSubdomain({ hostname = "", testDomain = "" } = {}) {
  if (testDomain) {
    return testDomain.includes(".") ? testDomain.split(".")[0] : testDomain;
  }

  const normalizedHostname = hostname.toLowerCase();
  if (
    normalizedHostname === "localhost" ||
    normalizedHostname === "tbdevdash.web.app" ||
    normalizedHostname.startsWith("dashboard.") ||
    normalizedHostname.endsWith(".web.app") ||
    normalizedHostname.endsWith(".firebaseapp.com")
  ) {
    return null;
  }

  const parts = normalizedHostname.split(".");
  return parts.length > 2 ? parts[0] : null;
}
